/* eslint-disable import/no-cycle */
import { CustomFieldRelationGQLFields, ShortcutGQLFields, } from '../../types/fields.generated.js';
import { embedGQLFields } from '../media/embed.fields.js';
import { mediaGQLFields } from '../media/media.fields.js';
import { memberGQLFields } from '../network/member.fields.js';
import { postAuthMemberPropsGQLFields, } from '../permission/postAuthMemberProps.fields.js';
import { postTypeGQLFields, } from '../post-type/postType.fields.js';
import { spaceGQLFields } from '../space/space.fields.js';
import { spaceMemberGQLFields, } from '../space/spaceMember.fields.js';
import { fileGQLFields } from './file.fields.js';
import { postLastActivityDetailGQLFields, } from './post-last-activity-detail.fields.js';
import { reactionGQLFields } from './reaction.fields.js';
import { tagGQLFields } from './tag.fields.js';
export const BASIC_POST_FIELDS = {
    owner: 'all',
};
export const ALL_POST_FIELDS = {
    authMemberProps: 'all',
    owner: 'all',
    createdBy: 'basic',
    tags: 'basic',
    attachments: 'basic',
    embeds: 'basic',
    mentions: 'basic',
    space: 'basic',
    reactions: { fields: 'basic', variables: { limit: 10 } },
    replies: { fields: 'basic', variables: { limit: 2 } },
    repliedTos: 'basic',
    repliedTo: 'basic',
};
export const DEFAULT_POST_FIELDS = {
    tags: 'basic',
    owner: {
        member: { profilePicture: 'basic', badges: 'all' },
    },
    postType: {
        postFields: 'all',
        validReplyTypes: 'all',
    },
    embeds: 'basic',
    mentions: 'basic',
    space: 'default',
    attachments: 'basic',
    authMemberProps: 'all',
    reactions: { fields: 'all', variables: { limit: 10 } },
    repliedTos: 'basic',
    pinnedReplies: {
        mentions: 'basic',
        embeds: 'basic',
        attachments: 'basic',
        owner: {
            member: { profilePicture: 'basic', badges: 'all' },
        },
    },
    replies: {
        fields: {
            authMemberProps: 'all',
            embeds: 'basic',
            mentions: 'basic',
            attachments: 'basic',
            owner: {
                member: { profilePicture: 'basic', badges: 'all' },
            },
            reactions: { fields: 'all', variables: { limit: 10 } },
        },
        variables: {
            limit: 2,
            reverse: true,
        },
    },
};
export function postGQLFields(fields) {
    var _a, _b, _c;
    if (fields === 'basic') {
        fields = BASIC_POST_FIELDS;
    }
    if (fields === 'all') {
        fields = ALL_POST_FIELDS;
    }
    if (fields === 'default') {
        fields = DEFAULT_POST_FIELDS;
    }
    return `
    id
    slug
    mappingFields {
      key
      type
      value
    }
    fields {
      key
      value
      relationEntities {
        ${CustomFieldRelationGQLFields({
        medias: {
            onEmoji: 'all',
            onFile: 'all',
            onImage: 'all',
        },
        members: {
            profilePicture: {
                onImage: {
                    urls: 'all',
                },
            },
        },
        posts: 'basic',
        spaces: {
            image: {
                onEmoji: 'all',
                onImage: {
                    urls: 'all',
                },
            },
        },
        tags: 'basic',
    })}
      }
    }    
    followersCount
    postTypeId
    reactionsCount
    hasMoreContent
    isAnonymous
    isHidden
    shortContent
    createdAt
    publishedAt
    ownerId
    createdById
    status
    spaceId
    imageIds
    pinnedInto
    repliesCount
    totalRepliesCount
    locked
    repliedToIds
    repliedToId
    topicIds
    title
    description
    ${fields.shortcuts
        ? `
        shortcuts{${ShortcutGQLFields({
            favicon: 'all',
        })}}
        
        `
        : ''}
    thumbnail {
      ${mediaGQLFields()}
    }
    embedIds
    mentionedMembers
    primaryReactionType
    lastActivityAt
    language
    customSeoDetail {
      description
      noIndex
      thumbnail {
        ${mediaGQLFields()}
      }
      thumbnailId
      title
      canonicalUrl
    }
    relativeUrl
    url
    ${fields.attachments
        ? `
        attachments {
          ${fileGQLFields()}
        }
      `
        : ''}
    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${postAuthMemberPropsGQLFields(fields.authMemberProps)}
      }`
        : ``}
    ${fields.postType
        ? `
      postType {
        ${postTypeGQLFields(fields.postType)}
      }
    `
        : ``}
    ${fields.owner
        ? `
      owner {
        ${spaceMemberGQLFields(fields.owner)}
      }
    `
        : ``}
    ${fields.createdBy
        ? `
      createdBy {
        ${spaceMemberGQLFields(fields.createdBy)}
      }
    `
        : ``}
    ${fields.tags
        ? `
      tags {
        ${tagGQLFields(fields.tags)}
      }
    `
        : ``}
    ${fields.embeds
        ? `
      embeds {
        ${embedGQLFields(fields.embeds)}
      }
    `
        : ``}
    ${fields.mentions
        ? `
      mentions {
        ${memberGQLFields(fields.mentions)}
      }
    `
        : ``}
    ${fields.space
        ? `
      space {
        ${spaceGQLFields(fields.space)}
      }
    `
        : ``}
    ${fields.reactions
        ? `
      reactions {
        ${reactionGQLFields(fields.reactions)}
      }
    `
        : ``}
    ${((_a = fields.replies) === null || _a === void 0 ? void 0 : _a.fields)
        ? `
      replies(limit: ${fields.replies.variables.limit || 1}, reverse: ${((_c = (_b = fields.replies) === null || _b === void 0 ? void 0 : _b.variables) === null || _c === void 0 ? void 0 : _c.reverse) || false} ) {
        nodes {
          ${postGQLFields(fields.replies.fields)}
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    `
        : ``}
    ${fields.repliedTo
        ? `
      repliedTo {
        ${postGQLFields(fields.repliedTo)}
      }
    `
        : ``}
    ${fields.repliedTos
        ? `
      repliedTos {
        ${postGQLFields(fields.repliedTos)}
      }
    `
        : ``}
    ${fields.pinnedReplies
        ? `
        pinnedReplies {
        ${postGQLFields(fields.pinnedReplies)}
      }
    `
        : ``}    
    ${fields.lastActivityDetail
        ? `
      lastActivityDetail {
        ${postLastActivityDetailGQLFields(fields.lastActivityDetail)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=posts.fields.js.map